import { memo } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * SightingStreakBadge - Shows sighting streak or weekly activity
 * Shows 🔥 streak when 3+ consecutive active days in last 14 days,
 * or a "Seen N× this week" label when there is recent but non-streak activity.
 *
 * @param {number} streakDays   - Distinct days with sightings in last 14d
 * @param {number} sightingsWeek - Total sightings in last 7d
 * @idempotent @atomic
 */
const SightingStreakBadge = memo(function SightingStreakBadge({ streakDays = 0, sightingsWeek = 0 }) {
  const { t } = useTranslation()

  if (streakDays >= 3) {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium text-orange-600 bg-orange-50 border border-orange-200 rounded-full px-2 py-0.5">
        🔥 {t('entity.streakDays', '{{count}} day streak', { count: streakDays })}
      </span>
    )
  }

  if (sightingsWeek > 0) {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-blue-600 bg-blue-50 border border-blue-200 rounded-full px-2 py-0.5">
        📍 {t('entity.seenThisWeek', 'Seen {{count}}× this week', { count: sightingsWeek })}
      </span>
    )
  }

  return null
})

export default SightingStreakBadge
